<script>
import { useAlert } from 'dashboard/composables';
import Spinner from 'shared/components/Spinner.vue';

const ATTACHMENT_ACCEPT = [
  'image/*',
  'video/*',
  'audio/*',
  '.pdf',
  '.ogg',
  '.oga',
  '.opus',
  '.mp3',
  '.m4a',
  '.aac',
  '.wav',
  '.amr',
].join(',');

export default {
  components: {
    Spinner,
  },
  props: {
    initialFileName: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      uploadState: 'idle',
      label: this.$t('AUTOMATION.ATTACHMENT.LABEL_IDLE'),
      attachmentAccept: ATTACHMENT_ACCEPT,
    };
  },
  mounted() {
    if (this.initialFileName) {
      this.label = this.initialFileName;
      this.uploadState = 'uploaded';
    }
  },
  methods: {
    async onChangeFile(event) {
      this.uploadState = 'processing';
      this.label = this.$t('AUTOMATION.ATTACHMENT.LABEL_UPLOADING');
      try {
        const file = event.target.files[0];
        const id = await this.$store.dispatch(
          'automations/uploadAttachment',
          file
        );
        this.$emit('update:modelValue', [id]);
        this.uploadState = 'uploaded';
        this.label = this.$t('AUTOMATION.ATTACHMENT.LABEL_UPLOADED');
      } catch (error) {
        this.uploadState = 'failed';
        this.label = this.$t('AUTOMATION.ATTACHMENT.LABEL_UPLOAD_FAILED');
        useAlert(this.$t('AUTOMATION.ATTACHMENT.UPLOAD_ERROR'));
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-1 w-full">
    <label class="input-wrapper" :class="uploadState">
      <input
        v-if="uploadState !== 'processing'"
        type="file"
        name="attachment"
        :accept="attachmentAccept"
        :class="uploadState === 'processing' ? 'disabled' : ''"
        @change="onChangeFile"
      />
      <Spinner v-if="uploadState === 'processing'" />
      <fluent-icon v-if="uploadState === 'idle'" icon="file-upload" />
      <fluent-icon
        v-if="uploadState === 'uploaded'"
        icon="checkmark-circle"
        type="outline"
        class="success-icon"
      />
      <fluent-icon
        v-if="uploadState === 'failed'"
        icon="dismiss-circle"
        type="outline"
        class="error-icon"
      />
      <p class="file-button">{{ label }}</p>
    </label>
    <p class="mb-0 text-xs text-n-slate-11">
      {{ $t('AUTOMATION.ATTACHMENT.AUDIO_HINT') }}
    </p>
  </div>
</template>

<style scoped>
input[type='file'] {
  @apply hidden;
}
.input-wrapper {
  @apply flex h-8 bg-n-background py-1 px-2 items-center text-xs cursor-pointer rounded-lg border border-dashed border-n-strong;
}
.success-icon {
  @apply text-n-teal-9 mr-2;
}
.error-icon {
  @apply text-n-ruby-9 mr-2;
}

.processing {
  @apply cursor-not-allowed opacity-90;
}
.file-button {
  @apply whitespace-nowrap overflow-hidden text-ellipsis w-full mb-0;
}
</style>
